import { render, staticRenderFns } from "./viewsResonPop.vue?vue&type=template&id=fd00613c"
import script from "./viewsResonPop.vue?vue&type=script&lang=js"
export * from "./viewsResonPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports